// extracted by mini-css-extract-plugin
export var hideMobileMenu = "SidebarMenu-module--hide-mobile-menu--ea485";
export var navStyle = "SidebarMenu-module--navStyle--94e7c";
export var showMobileMenu = "SidebarMenu-module--show-mobile-menu--05052";